export const getAmountSStorage = () => sessionStorage.getItem('amount');

export const getAmountCommissionSStorage = () => {
  const item = sessionStorage.getItem('commission');
  if (!item) return [];
  try {
    return JSON.parse(item);
  } catch {
    return null;
  }
};
